export default {
      id: "pdf-download-usage",
      viewBox: "0 0 51 45",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#pdf-download",
      toString: function () {
        return this.url;
      }
    }